// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__3RzsB","sidebar-main":"Sidebar_sidebar-main__K5tFF","sidebar-closed":"Sidebar_sidebar-closed__Dnbzq"};